import styled from "styled-components";
import { staffLines } from "../../../common/styles";

export const ErrorPage = styled.div`
    background-color: ${p => p.theme.c.dark};
    padding: 0 12px;
    background-size: 100% 120px;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    ${staffLines}

    h1 {
        color: ${p => p.theme.c.incorrect};
        text-align: center;
        margin-top: 0;
        margin-bottom: 12px;
    }

    h2 {
        color: ${p => p.theme.c.boost};
        margin-top: 0;
        text-align: center;
        font-size: 22px;
        font-weight: 400;
    }

    p {
        max-width: 400px;
        text-align: center;
        line-height: 1.5;
        font-size: 17px;
        margin-top: 0;
        font-weight: 300;
        box-sizing: border-box;
        color: ${p => p.theme.mode === "dark" ? p.theme.c.whiteOnActive : p.theme.c.dark};
        margin-bottom: 6px;
    }

    form .button {
        margin-bottom: 0;
    }

    textarea {
        max-height: 110px;
    }
`;

export const LogoCropper = styled.div`
    width: 64px;
    overflow: hidden;
    margin: auto;
    svg {
        margin-right: 4px;
        width: 376px;
        height: 80px;
        fill: ${p => p.theme.c.boost};
        margin-top: 12px;
    }
`;

export const RefreshWrapper = styled.div`
    text-align: center;
    margin-bottom: 12px;

    > div {
        margin: 0 6px;
    }
`;

export const Wrapper = styled.div`
    background: ${p => p.theme.mode === "dark" ? p.theme.c.snow : p.theme.c.light};
    border-radius: 20px;
    border: ${p => p.theme.c.incorrect} 10px solid;
    padding: 20px;
`;

export const Success = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${p => p.theme.c.correct};

    .i-check {
        margin-right: 6px;
        font-size: 28px;
        display: inline-block;
    }
`;
